export default {
  // KycRecordHistory.tsx
  'kyc.history.title': 'Historial de Solicitud de KYC',
  'kyc.history.memberAccount': 'Cuenta de Miembro',
  'kyc.history.realName': 'Nombre Real',
  'kyc.history.idPhoto': 'Documento de Identidad',
  'kyc.infoImg.documentPhoto': 'Foto de Documento',
  'kyc.infoImg.handheldPhoto': 'Foto de Documento en Mano',
  'kyc.infoImg.selfiePhoto': 'Foto de Selfie',
  'kyc.infoImg.noPhoto': 'Sin Foto',
  'kyc.history.viewPhoto': 'Ver Foto',
  'kyc.history.birthDate': 'Fecha de Nacimiento',
  'kyc.history.info': 'Información básica',
  'kyc.history.documentType': 'Tipo de documento',
  'kyc.history.documentCode': 'Número de documento',
  'kyc.history.gender': 'Género',
  'kyc.history.nationality': 'Nacionalidad',
  'kyc.history.incomeSource': 'Fuente de ingresos',
  'kyc.history.monthlyIncomeRange': 'Rango de Ingresos Mensuales',
  'kyc.history.occupation': 'Ocupación',
  'kyc.history.currentAddress': 'Dirección actual',
  'kyc.history.permanentAddress': 'Dirección permanente',
  'kyc.history.birthAddress': 'Lugar de nacimiento',
  'kyc.history.kycCount': 'Cantidad de Solicitudes',
  'kyc.history.operation': 'Información de Operación',
  'kyc.history.submitTime': 'Hora de Envío',
  'kyc.history.submitter': 'Remitente',
  'kyc.history.reviewTime': 'Hora de Revisión',
  'kyc.history.reviewer': 'Revisor',
  'kyc.history.failureReason': 'Razón de Fallo',
  'kyc.history.status': 'Estado',
  'kyc.history.status.simple.pending': 'KYC de registro pendiente de revisión',
  'kyc.history.status.whole.pending': 'KYC de retiro pendiente de revisión',
  'kyc.history.status.simple.success': 'Éxito de KYC de registro',
  'kyc.history.status.whole.success': 'Éxito de KYC de retiro',
  'kyc.history.status.simple.failed': 'KYC de registro fallido',
  'kyc.history.status.whole.failed': 'KYC de retiro fallido',
  'kyc.history.status.simple.blacklist': 'KYC de registro en lista negra',
  'kyc.history.status.whole.blacklist': 'KYC de retiro en lista negra',
  'kyc.history.status.unknown': 'Desconocido',

  'kyc.sup.status.pending': 'No enviado',
  'kyc.sup.status.submit': 'Enviado',
  'kyc.sup.status.rejected': 'Rechazado',
  'kyc.sup.status.approved': 'Aprobado',
  'kyc.sup.approve.confirm.approve': '¿Confirmar que la solicitud de complementar la información de KYC del miembro ha sido aprobada?',
  'kyc.sup.approve.confirm.reject': '¿Confirmar que la solicitud de complementar la información de KYC del miembro debe ser rechazada?',

  // KycRecordApprove.tsx
  'kyc.approve.title.success': 'Confirmación de Aprobación',
  'kyc.approve.title.reject': 'Confirmación de Rechazo',
  'kyc.update.title.document': 'Actualizar Documento',
  'kyc.approve.confirm.success': '¿Confirmar configurar esta solicitud de KYC como aprobada?',
  'kyc.approve.failureReason': 'Razón de Fallo',
  'kyc.approve.failureReason.placeholder': 'Por favor ingrese razón de fallo',
  'kyc.approve.error.recordNotExist': 'Los datos del registro no existen',

  // KycRecordData.tsx
  'kyc.data.setSuccess': 'Configurar como Exitoso',
  'kyc.data.setFailed': 'Configurar como Fallido',
  'kyc.data.viewFailureReason': 'Ver Razón de Fallo',
  'kyc.data.viewHistory': 'Ver Historial',
  'kyc.data.document': 'Actualizar Documento',
  'kyc.data.confirm.setFailed': '¿Confirmar configurar esta solicitud de KYC como fallida?',
  'kyc.data.error.loadFailed': 'Error al cargar datos',

  // KycRecordFrm.tsx
  'kyc.form.submitTime': 'Hora de Envío',
  'kyc.form.reviewTime': 'Hora de Revisión',
  'kyc.form.memberAccount': 'Cuenta de Miembro',
  'kyc.form.memberAccount.placeholder': 'Por favor ingrese cuenta de miembro',
  'kyc.form.status': 'Estado',
  'kyc.form.status.placeholder': 'Por favor seleccionar estado',
  'kyc.form.status.pending': 'Pendiente',
  'kyc.form.status.success': 'Aprobado',
  'kyc.form.status.failed': 'Rechazado',
  'kyc.form.batchSuccess': 'Configurar Lote como Exitoso',
  'kyc.form.batchFailed': 'Configurar Lote como Fallido',
  'kyc.form.confirm.batchFailed': '¿Confirmar configurar solicitudes de KYC seleccionadas como fallidas?',

  // System Common
  'sys.operation.title': 'Operación'
};
